import { create } from 'zustand';

export type SystemDateStatus = 'idle' | 'loading' | 'ready' | 'error';

type SystemDateState = {
  businessDate: string | null;
  systemTimestamp: string | null;
  status: SystemDateStatus;
  errorMessage: string | null;
  setLoading: () => void;
  setSystemDate: (payload: { businessDate: string; systemTimestamp: string | null }) => void;
  setError: (message: string) => void;
  reset: () => void;
};

const INITIAL_STATE = {
  businessDate: null,
  systemTimestamp: null,
  status: 'idle' as SystemDateStatus,
  errorMessage: null,
};

export const useSystemDateStore = create<SystemDateState>((set) => ({
  ...INITIAL_STATE,
  setLoading: () =>
    set((state) => (state.businessDate ? state : { ...state, status: 'loading', errorMessage: null })),
  setSystemDate: ({ businessDate, systemTimestamp }) =>
    set({
      businessDate,
      systemTimestamp,
      status: 'ready',
      errorMessage: null,
    }),
  setError: (message) =>
    set((state) => ({
      ...state,
      status: state.businessDate ? 'ready' : 'error',
      errorMessage: message,
    })),
  reset: () => set(INITIAL_STATE),
}));

export function businessDateToPeriod(businessDate: string | null | undefined): string {
  if (!businessDate || businessDate.length < 7) return '';
  return businessDate.slice(0, 7);
}

export const SYSTEM_DATE_REFRESH_EVENT = 'trms:system-date-refresh';

export function requestSystemDateRefresh(): void {
  window.dispatchEvent(new Event(SYSTEM_DATE_REFRESH_EVENT));
}
